export default [
	{
		path: '/',
		redirect: '/mall/home'
	},
	{
		path: '/404',
		name: '404',
		component: () => import('@/page/404.vue'),
		meta: {
			title: '404',
			auth: false, //是否需要权限判断
			keepAlive: false
		}
	},
	{
		path: '/403',
		name: '403',
		component: () => import('@/page/403.vue'),
		meta: {
			title: '无权限',
			auth: false, //是否需要权限判断
			keepAlive: false
		}
	},
	{
		path: '/:pathMatch(.*)*',
		redirect: '/404'
	}
]
